function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { getRangeValue } from "../Utils/NumberUtils";
import { isSsr } from "../Utils/Utils";
export var Retina = /*#__PURE__*/function () {
  function Retina(container) {
    _classCallCheck(this, Retina);

    this.container = container;
  }

  _createClass(Retina, [{
    key: "init",
    value: function init() {
      var container = this.container,
          options = container.actualOptions;
      this.pixelRatio = !options.detectRetina || isSsr() ? 1 : window.devicePixelRatio;
      this.reduceFactor = 1;
      var ratio = this.pixelRatio;

      if (container.canvas.element) {
        var element = container.canvas.element;
        container.canvas.size.width = element.offsetWidth * ratio;
        container.canvas.size.height = element.offsetHeight * ratio;
      }

      var particles = options.particles;
      this.attractDistance = getRangeValue(particles.move.attract.distance) * ratio;
      this.sizeAnimationSpeed = getRangeValue(particles.size.animation.speed) * ratio;
      this.maxSpeed = getRangeValue(particles.move.gravity.maxSpeed) * ratio;
    }
  }, {
    key: "initParticle",
    value: function initParticle(particle) {
      var options = particle.options,
          ratio = this.pixelRatio,
          moveDistance = options.move.distance,
          props = particle.retina;
      props.attractDistance = getRangeValue(options.move.attract.distance) * ratio;
      props.moveDrift = getRangeValue(options.move.drift) * ratio;
      props.moveSpeed = getRangeValue(options.move.speed) * ratio;
      props.sizeAnimationSpeed = getRangeValue(options.size.animation.speed) * ratio;
      var maxDistance = props.maxDistance;
      maxDistance.horizontal = moveDistance.horizontal !== undefined ? moveDistance.horizontal * ratio : undefined;
      maxDistance.vertical = moveDistance.vertical !== undefined ? moveDistance.vertical * ratio : undefined;
      props.maxSpeed = getRangeValue(options.move.gravity.maxSpeed) * ratio;
    }
  }]);

  return Retina;
}();